import { useEffect, useState } from "react";
import Table from "../../../components/common/table/Table";
import Title from "../../../components/common/title/Title";
import { getApi } from "../../../services/api/globalApi";
import ExportExcel from "../../../components/common/export-exel/ExportExel";
import { convertDate } from "../../../utils/convertDate";
import moment from "jalali-moment";
import { socialMediaCustomerReportsColumns } from "../../../constant/tablesColumns/tablesColums";
import SocialMediaCustomerReportFilter from "./socialMediaCustomerReportFilter";

export default function SocialMediaCustomerReport() {
  const [reportsData, setReportsData] = useState([]);
  const [activeSearchButton, setActiveSearchButton] = useState(true);

  const getProductReports = async (params) => {
    const path = "admin/reports/getSocialCustomersOrderSummary";
    try {
      setActiveSearchButton(false);
      const response = await getApi({ path, params: { ...params } });
      const result = response?.data?.result || [];
      const convertedData = convertData(result);
      setReportsData(convertedData);
      setActiveSearchButton(true);
    } catch (error) {
      console.log(error);
    }
  };
  const convertData = (data) => {
    return data.map((item) => {
      const d = {
        ...item,
        linkCodes: item.lastOrder?.linkCode,
        lastProducts: item.lastOrder?.products
          .map((item) => item.productName)
          ?.join(","),
        lastPaymentDate: convertDate(item.lastOrder?.paymentDate),
      };
      delete d.lastOrder;
      return d;
    });
  };
  useEffect(() => {
    filterDataHandler({
      from: moment().locale("en").format("YYYY-MM-DD"),
      to: moment().locale("en").format("YYYY-MM-DD"),
    });
  }, []);

  const [filter, setFilter] = useState();

  const filterDataHandler = (newParams) => {
    setFilter({ ...filter, ...newParams });
    const allFilter = {
      ...filter,
      ...newParams,
    };
    getProductReports(allFilter);
  };

  return (
    <div className="bg-white dark:bg-gray-900 rounded-3xl p-6">
      <div className="flex flex-col sm:flex-row justify-betwseen items-center">
        <Title title={"فروش مشتریان شبکه اجتماعی"} />
        <div className="w-full mt-4 sm:mt-0 flex justify-end">
          <ExportExcel jsonData={reportsData || []} />
        </div>
      </div>

      <SocialMediaCustomerReportFilter
        filterDataHandler={filterDataHandler}
        activeSearchButton={activeSearchButton}
      />
      <Table
        columns={socialMediaCustomerReportsColumns}
        rows={reportsData || []}
      />
    </div>
  );
}
